<script setup lang="ts" generic="T extends AcceptableValue">
import { ListboxItem, useId, type AcceptableValue } from "reka-ui";

const props = defineProps<{
	value: T;
}>();

const emit = defineEmits<{
	select: [value: T];
}>();

const id = useId(undefined, "ui-combobox-custom-item");
</script>

<template>
	<ListboxItem
		:id="id"
		class="command-item group"
		:value="props.value"
		@select="
			() => {
				emit('select', props.value);
			}
		"
	>
		<div>
			<slot />
		</div>
	</ListboxItem>
</template>
